import { z } from 'zod';
import { idSchema, isoDateSchema, signedCentsSchema, timestampSchema } from './common.js';
// --- Affectation et validation (lot 8, décision D6 — sans LLM) --------------------------
/**
 * `action_required` : aucune règle ne correspond, ou le montant sort de la fourchette
 * connue. `validated` : affectée (automatiquement ou manuellement) et immuable — voir
 * le déclencheur `transactions_immutable_once_validated`.
 */
export const TRANSACTION_STATUSES = ['action_required', 'validated'];
/**
 * `exact` : noyau normalisé identique à une règle. `similarity` : similarité de Jaccard des
 * jetons au-dessus de 0,85. `manual` : affectée à la main depuis la file d'attente.
 */
export const ASSIGNMENT_METHODS = ['exact', 'similarity', 'manual'];
export const transactionSchema = z.object({
    id: idSchema,
    bankAccountId: idSchema,
    statementId: idSchema,
    sourcePage: z.number().int().nonnegative().nullable(),
    txDate: isoDateSchema,
    valueDate: isoDateSchema,
    label: z.string(),
    normalizedLabel: z.string(),
    amountCents: signedCentsSchema,
    propertyId: idSchema.nullable(),
    categoryId: idSchema.nullable(),
    status: z.enum(TRANSACTION_STATUSES),
    assignmentMethod: z.enum(ASSIGNMENT_METHODS).nullable(),
    validatedAt: timestampSchema.nullable(),
    createdAt: timestampSchema,
    /** Annotation libre : seul champ modifiable après validation (voir le trigger d'immuabilité). */
    note: z.string().trim().min(1).max(500).nullable(),
});
export const transactionNoteInputSchema = z.object({
    note: z.string().trim().min(1).max(500).nullable(),
});
/** Affectation manuelle d'une écriture `action_required` : crée ou renforce une règle apprise. */
export const transactionAssignInputSchema = z.object({
    propertyId: idSchema,
    categoryId: idSchema,
});
export const transactionBulkAssignInputSchema = z.object({
    transactionIds: z.array(idSchema).min(1).max(500),
    propertyId: idSchema,
    categoryId: idSchema,
});
export const transactionBulkAssignResponseSchema = z.object({
    assigned: z.array(transactionSchema),
});
export const assignmentRuleSchema = z.object({
    id: idSchema,
    normalizedLabel: z.string(),
    propertyId: idSchema,
    categoryId: idSchema,
    minAmountCents: signedCentsSchema,
    maxAmountCents: signedCentsSchema,
    timesApplied: z.number().int().nonnegative(),
    lastAppliedAt: timestampSchema.nullable(),
    isActive: z.boolean(),
    createdAt: timestampSchema,
    updatedAt: timestampSchema,
});
/** Correction d'une règle : le noyau normalisé ne change pas, c'est sa clé. */
export const assignmentRuleUpdateSchema = z
    .object({
    propertyId: idSchema,
    categoryId: idSchema,
    minAmountCents: signedCentsSchema,
    maxAmountCents: signedCentsSchema,
})
    .partial()
    .refine((value) => Object.keys(value).length > 0, { message: 'Aucun champ à modifier' })
    .refine((value) => value.minAmountCents === undefined ||
    value.maxAmountCents === undefined ||
    value.minAmountCents <= value.maxAmountCents, { message: 'Le minimum ne peut pas dépasser le maximum' });
export const assignmentRuleReplayResponseSchema = z.object({
    revalidated: z.number().int().nonnegative(),
});
//# sourceMappingURL=assignment.js.map